import { IPartyForUser } from '../../PartyClientResponse';
import React, { useEffect, useRef } from 'react';
import { useVideoController } from '../../controller/video/VideoControlContext';
import { useAppState, ActionType } from '../../state/AppState';
import useResizeObserver from 'use-resize-observer';

const SpotlightedParticipant = ({
  party,
}: {
  height: number;
  party: IPartyForUser;
  width: number;
  audioEnabled: boolean;
}) => {
  const { dispatch } = useAppState();
  useVideoController();
  const ref = useRef<HTMLDivElement>(null);
  const {
    width: spotlightedAreaWidth = 0,
    height: spotlightedAreaHeight = 0,
  } = useResizeObserver<HTMLDivElement>({ ref });

  const participant = party.stage.spotlight?.participant;

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    dispatch({
      type: ActionType.SetSpotlightPosition,
      position: {
        ref,
        left: ref.current.offsetLeft,
        top: ref.current.offsetTop,
        width: spotlightedAreaWidth,
        height: spotlightedAreaHeight,
      },
    });
  }, [ref, spotlightedAreaHeight, spotlightedAreaWidth, dispatch]);

  if (!participant) {
    return <div />;
  }

  if (!party.stage.participants[participant.uid]) {
    return <div />;
  }

  // const isSelf = participant.uid === user?.uid;
  // const transformX = isSelf ? 0 : window.innerWidth - (ref.current?.clientLeft || 0);
  // const transformY = isSelf ? 0 : ref.current?.clientTop || 0;
  // const scale = isSelf ? 1 : 0.1;

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', flexGrow: 1 }} ref={ref}>
      {/* <div
        style={{
          width: '100%',
          height: '100%',
          opacity: isSelf ? 1 : 0,
          transform: `translateX(${transformX}px) translateY(${transformY}px) scale(${scale})`,
        }}
        className={`self-spotlight-container ${isSelf ? 'self' : ''}`}> */}
      {/* {isSelf && (
          <div>
            <VideoWithRef
              className='ot-video-container square'
              key={participant.uid}
              videoTrack={localVideoTrack}
              style={{ width, height, transform: 'scaleX(-1)' }}
            />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <UnspotlightButton participant={participant} />
            </div>
          </div>
        )} */}
      {/* </div> */}
    </div>
    // <StreamPlayer
    //   className='spotlight'
    //   height={height}
    //   key={`${participant.uid}-StreamPlayer`}
    //   width={width}
    //   participant={participant}
    //   audioEnabled={false}></StreamPlayer>
  );
};

export default SpotlightedParticipant;
